var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credible-set-container"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm ml-4 btn-xs",on:{"click":_vm.performSearch}},[_vm._v("View")]),_c('span',[_vm._v(_vm._s(_vm.cellValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }